import { memo, useMemo } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

type Props = {
	planName?: InputMaybe<string>;
};

export const PlanNameOfDetailInfoCompositions = memo(({ planName }: Props) => {
	const planNameText = useMemo(() => planName ?? "プランは選択されていません", [planName]);

	return <p>{planNameText}</p>;
});
